/* eslint-disable import/prefer-default-export */

export const EMAIL_MIN_LENGTH = 6;
